// extracted by mini-css-extract-plugin
export default {"floating-button":"abqWYBreewg8XQTTFXSaiA=="};